<template>
    <megabit-base-dialog :show-dialog="showGuestDialog">
      <template v-slot:body>
        <v-card dark class="pt-4 pb-2">
          <v-card-text>
            <v-form v-model="formGuestValid" ref="formGuest">
            <v-row no-gutters>
              <v-col cols="12">
                  <v-text-field
                    outlined
                    dense
                    placeholder="RG/CPF ou CNPJ"
                    label="Informe o documento de cadastro"
                    type="number"
                    class="text-caption ml-1"
                    v-model="form.document"
                    :rules="formRules.documentRules"
                  >
                  </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="9">
                  <v-text-field
                  outlined
                  dense
                  placeholder="Email"
                  label="Informe seu email"
                  class="text-caption ml-1"
                  v-model="form.email"
                  :rules="formRules.emailRules"
                  >
                  </v-text-field>
              </v-col>
              <v-col cols="3">
                        <v-btn
                            color="warning"
                            @click="requestAuthentication"
                            :loading="sendingRequest"
                            >
                            <span class="small text-button font-weight-regular">
                               Enviar
                            </span>
                            <v-icon color="white" small right>
                                mdi-email-send
                            </v-icon>
                        </v-btn>
              </v-col>
            </v-row>
            <v-row v-show="tokenSend">
              <v-col cols="12">
                  <v-text-field
                  outlined
                  dense
                  :placeholder="`Token enviado no e-mail ${form.email}`"
                  label="Insira o Token"
                  class="text-caption ml-1"
                  v-model="form.guestToken"
                  :rules="formRules.emailRules"
                  >
                  </v-text-field>
              </v-col>
            </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              dark
              color="red lighten-1"
              @click="$emit('closeGuestLogin')"
            >
              <span>Fechar</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn dark color="teal lighten-1" @click="loginGuest" :disabled="!tokenSend">
              <span>Acessar</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </megabit-base-dialog>  
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import { mapActions } from 'vuex'
export default {
    components:{'megabit-base-dialog':BaseDialog},
    data: () => {
        return {
            formGuestValid: false,
            tokenSend: false,
            sendingRequest: false,            
            form: {
                document: '',
                email: '',
                guestToken: '',
            },                        
            formRules: {
                documentRules: [
                  (v) => !!v || 'Este campo é obrigatório.',
                  (v) =>
                    v.length <= 14 ||
                    'Este campo deve possuir no máximo 14 caractéres.',
                ],
                emailRules: [
                  (v) => !!v || 'Este campo é obrigatório.',
                ] 
            }
        }
    },
    methods:{
    ...mapActions({
      loginGuestUser: 'authModule/loginGuestUser',
      sendEmail: 'authModule/sendEmail',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage'      
    }),        
    async requestAuthentication(){
      try{
        this.setLoadingDialogMessage(`Verificando acesso [${this.form.email}]`);
        this.showLoadingDialog(true);
        this.sendingRequest = !this.sendingRequest;
        let response = await this.sendEmail({
            doc: this.form.document,
            email: this.form.email
          });
        
        if(response.type === 'Notification')
          this.$toasted.info(`Sua conta ainda não foi confirmada. Um email foi enviado 
          para [${this.form.email}]. Após confirmar sua conta, clique novamente em "ENVIAR"`,{duration:null})
        else
        if(response.type === 'Authorization'){
          this.tokenSend = true;
          this.$toasted.info(response.status, {duration: null})
        }else
          this.$toasted.info(response.status, {duration: null})

      }catch(error){
        this.$toasted.error(error,{duration:null});
      }finally{
        this.showLoadingDialog(false);         
        this.sendingRequest = !this.sendingRequest;
      }

    },
    async loginGuest() {
      try {
        this.setLoadingDialogMessage('Autenticando acesso...')
        this.showLoadingDialog(true);

        this.$refs.formGuest.validate()

        if (this.formGuestValid) {
          let loginData = {}
          
          loginData.doc = this.form.document
          loginData.email = this.form.email
          loginData.token = this.form.guestToken

          await this.loginGuestUser(loginData)
          this.$toasted.info('Usuário autenticado com sucesso');

          this.$router.push({ name: 'Home' });
        
        } else {
          this.$toasted.error('Preencha corretamente o formulário',{duration: null})
        }

      } catch (error) {
        this.$toasted.error(error, {duratio: null});
      } finally {
        this.showLoadingDialog(false);
        this.$emit('closeGuestDialog');
      }
    },        
    },
    props:{
        showGuestDialog:{
            type: Boolean,
            required: true,
            default: false
        }
    }

}
</script>

<style>

</style>